/**
 * Edit goods receipt — mounts the shared composer in edit mode by threading
 * `grnId`. The composer loads the draft via `goodsReceipts.get`, overlays its
 * stored received / accepted / reject values on the PO's full line set, and
 * saves via `goodsReceipts.update` (or `update`-then-`post`). Only drafts are
 * editable; posted / void receipts have no edit affordance.
 *
 * @see prototype/purchases/goods-receipt-new.html — V1.1 composer baseline
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { hasPermission } from "@flint/api-contract";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { GrnComposerPage } from "../../../../features/goods-receipts/index.ts";
import { meQueryOptions } from "../../../../lib/session.ts";

export const Route = createFileRoute("/(workspace)/procurement/goods-receipts/$grnId/edit")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions).catch(() => null);
    const perms = me?.company?.permissions ?? [];
    if (!hasPermission(perms, "goodsReceipts.manage")) {
      throw notFound();
    }
  },
  component: EditGoodsReceiptRoute,
});

function EditGoodsReceiptRoute() {
  const { grnId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Procurement", to: "/" },
        { label: "Goods receipts", to: "/procurement/goods-receipts" },
        { label: "Edit" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <GrnComposerPage grnId={grnId} />
    </WorkspaceShell>
  );
}
